import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-after-auth',
  templateUrl: './after-auth.component.html',
  styleUrls: ['./after-auth.component.scss']
})
export class AfterAuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $('.grecaptcha-badge').hide();
  }

}
